module.exports = __webpack_public_path__ + "static/img/自动化营销.350a16b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/自动化营销.png
// module id = hG5X
// module chunks = 0